import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBhutan = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_833)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M20.4853 20.4853C15.799 25.1716 8.20101 25.1716 3.51469 20.4853C-1.17159 15.799 -1.17159 8.20101 3.51469 3.51469C3.51637 3.51469 14.2987 0.328735 18.985 5.01501C23.6713 9.70129 20.4885 20.482 20.4853 20.4853Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M20.4853 20.4853C25.1715 15.799 25.1715 8.20102 20.4853 3.51469C15.799 -1.17164 8.20101 -1.17159 3.51469 3.51469L20.4853 20.4853Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15.1367 15.1379C14.6437 15.3315 14.071 15.3109 13.5741 15.0321C12.6961 14.5393 12.3827 13.424 12.8756 12.5459L12.726 12.462C14.2293 12.0995 15.3415 10.7349 15.322 9.12469C15.3099 8.12358 14.8626 7.22794 14.1629 6.6151L13.0672 7.73757C13.4814 8.06766 13.75 8.574 13.7569 9.14368C13.7691 10.1506 12.9599 10.9796 11.9531 10.9918L11.9552 11.1632C10.8896 10.0426 9.15182 9.76168 7.76709 10.5837C6.90618 11.0948 6.35428 11.9299 6.17329 12.8423L7.69317 13.23C7.77197 12.7062 8.07614 12.2205 8.56603 11.9296C9.43186 11.4157 10.5544 11.702 11.0684 12.5678L11.216 12.4802C10.7782 13.9633 11.4038 15.6087 12.8081 16.397C13.6812 16.887 14.6804 16.9474 15.5611 16.6479L15.1367 15.1379ZM11.9657 12.035L11.9656 12.0351L11.9657 12.035Z",
				fill: "#FF9811"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16.4431 8.12723L15.5949 11.154L13.0501 10.6841L11.412 7.30743L6.98667 8.87779L6.63769 7.89436L5.47987 7.75172L6.35226 10.2103L9.39769 9.43139L10.2631 11.8702L8.15789 14.9772L11.7306 18.0243L11.0534 18.8182L11.5088 19.8924L13.2018 17.9075L11.0046 15.6595L12.684 13.6906L16.4273 13.9604L17.2799 9.3427L18.3061 9.53222L19.0087 8.60081L16.4431 8.12723ZM11.9991 12.0817V12.0817V12.0817Z",
				fill: "#FFEACF"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_833",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgBhutan;
